import api from "../../services/api";

const BASE_URL = "/api/v1/job-requisitions";

export const jobRequisitionService = {
  // Get all job requisitions with filtering and pagination
  getAllRequisitions: async (params = {}) => {
    try {
      const response = await api.get(BASE_URL, { params });
      return response.data.data || { requisitions: [], pagination: {} };
    } catch (error) {
      console.error("Job requisition service error:", error);
      throw error;
    }
  },

  // Get single requisition by ID
  getRequisitionById: async (id) => {
    const response = await api.get(`${BASE_URL}/${id}`);
    return response.data;
  },

  // Create new job requisition
  createRequisition: async (requisitionData) => {
    const response = await api.post(BASE_URL, requisitionData);
    return response.data;
  },

  // Update job requisition
  updateRequisition: async (id, requisitionData) => {
    const response = await api.put(`${BASE_URL}/${id}`, requisitionData);
    return response.data;
  },

  // Delete job requisition
  deleteRequisition: async (id) => {
    const response = await api.delete(`${BASE_URL}/${id}`);
    return response.data;
  },

  // Submit requisition for approval
  submitForApproval: async (id) => {
    const response = await api.post(`${BASE_URL}/${id}/submit`);
    return response.data;
  },

  // Approve or reject requisition
  processApproval: async (id, action, comments = "") => {
    const response = await api.post(`${BASE_URL}/${id}/approve`, {
      action,
      comments,
    });
    return response.data;
  },

  // Add comment to requisition
  addComment: async (id, comment) => {
    const response = await api.post(`${BASE_URL}/${id}/comments`, { comment });
    return response.data;
  },

  // Get requisition statistics
  getRequisitionStats: async () => {
    const response = await api.get(`${BASE_URL}/stats/overview`);
    return response.data;
  },
};
